/**
 * @description escape Regular_Expressions special_characters '^$.|*+?{\\[()'
 */
export default function getSafeRegExpString(str) {
  return str.replace(/([\^\$\.\|\*\+\?\{\\\[\(\)])/g, '\\$1');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/utils/getSafeRegExpString.js
// module id = 1052
// module chunks = 31